import { booleanAttribute, Component, Input } from "@angular/core";

@Component({
    selector: "app-progress-loading",
    templateUrl: "./progress-loading.component.html",
    styleUrl: "./progress-loading.component.scss",
    standalone: false
})
export class ProgressLoadingComponent {
  @Input({ transform: booleanAttribute }) isLoading = true;
  @Input() loadingClass = "min-h-60";
}
